import type { BlackFridayCampaignConfig } from "./config";

export type CampaignPhase = "upcoming" | "early-access" | "live" | "ended";

export interface CampaignBoundaries {
	earlyAccessStart: Date;
	publicStart: Date;
	endExclusive: Date;
}

/**
 * Die Kampagne läuft in deutscher Zeit. Der feste Offset aus der Konfiguration
 * macht die Grenzen unabhängig vom Aufenthaltsort der Besucherin.
 */
function localMidnight(isoDate: string, utcOffset: string): Date {
	return new Date(`${isoDate}T00:00:00${utcOffset}`);
}

export function getCampaignBoundaries(config: BlackFridayCampaignConfig): CampaignBoundaries {
	return {
		earlyAccessStart: localMidnight(config.dates.earlyAccess, config.utcOffset),
		publicStart: localMidnight(config.dates.publicStart, config.utcOffset),
		endExclusive: localMidnight(config.dates.endExclusive, config.utcOffset),
	};
}

/** Phase zum Zeitpunkt `now`; alle Grenzen sind halboffen (`[start, end)`). */
export function getCampaignPhase(now: Date, config: BlackFridayCampaignConfig): CampaignPhase {
	const time = now.getTime();
	const boundaries = getCampaignBoundaries(config);
	if (time < boundaries.earlyAccessStart.getTime()) return "upcoming";
	if (time < boundaries.publicStart.getTime()) return "early-access";
	if (time < boundaries.endExclusive.getTime()) return "live";
	return "ended";
}

/**
 * Zeitpunkt, auf den der Countdown zeigt: vor dem Start der Early-Access-Beginn,
 * im Early Access der öffentliche Start, während der Aktion das Ende.
 */
export function getCountdownTarget(phase: CampaignPhase, config: BlackFridayCampaignConfig): Date | null {
	const boundaries = getCampaignBoundaries(config);
	switch (phase) {
		case "upcoming":
			return boundaries.earlyAccessStart;
		case "early-access":
			return boundaries.publicStart;
		case "live":
			return boundaries.endExclusive;
		case "ended":
			return null;
	}
}
